<a class="Hashtag"
	*ngFor="let tag of hashtags"
	[href]="tag.href"
	[class.Hashtag--active]="tag.active"
	target="_blank"
>{{tag.name | hashtag}}</a>
